import { useMutation, useQuery } from '@tanstack/react-query'
import { listLocations, getLocation, createNewLocation, changeLocationStatus, updateLocation, deleteLocation, getLocationCameraList, createNewLocationCamera, deleteLocationCam, getLocationInvitationList, createNewLocationInvitation, cancelLocationInvitation, createNewLocationInvitationBulk, editLocationCamera, getCameraRecordingList } from '../api/locations'

export const useListLocationsQuery = (queryParams = '') => {
    return useQuery({
      queryKey: ['locations', queryParams],
      queryFn: () => listLocations(queryParams),
    });
};

export const useGetLocationQuery = (queryParams = '', entity) => {
  return useQuery({
    queryKey: ['location', queryParams],
    queryFn: () => getLocation(queryParams),
    enabled: entity === 'location' && !!queryParams
  });
};

export const useAddNewLocation = () => {
    return useMutation({
      mutationFn: createNewLocation
    })
};

export const useChangeLocationStatus = () => {
    return useMutation({
      mutationFn: changeLocationStatus
    })
};

export const useUpdateLocation = () => {
  return useMutation({
    mutationFn: updateLocation
  })
};

export const useDeleteLocation = () => {
  return useMutation({
    mutationFn: deleteLocation
  })
};

// Location Camera Part
export const useLocationCameraListQuery = (queryParams = '') => {
  return useQuery({
    queryKey: ['camera_list', queryParams],
    queryFn: () => getLocationCameraList(queryParams),
    enabled: !!queryParams
  });
};

// Location Camera recording Part
export const useCameraRecordingListQuery = (queryParams = '') => {
  return useQuery({
    queryKey: ['camera_recording_list', queryParams],
    queryFn: () => getCameraRecordingList(queryParams),
    enabled: !!queryParams
  });
};

export const useAddNewLocationCamera = () => {
  return useMutation({
    mutationFn: createNewLocationCamera
  })
};

export const useEditLocationCamera = () => {
  return useMutation({
    mutationFn: editLocationCamera
  })
};

export const useDeleteLocationCamera = () => {
  return useMutation({
    mutationFn: deleteLocationCam
  })
};

// Location Invitation Part
export const useLocationInviationListQuery = (queryParams = '') => {
  return useQuery({
    queryKey: ['invitation_list', queryParams],
    queryFn: () => getLocationInvitationList(queryParams),
    enabled: !!queryParams
  });
};

export const useAddNewLocationInvitation = () => {
  return useMutation({
    mutationFn: createNewLocationInvitation
  })
};

export const useCancelLocationInvitation = () => {
  return useMutation({
    mutationFn: cancelLocationInvitation
  })
};

export const useAddNewLocationInvitationBulk = () => {
  return useMutation({
    mutationFn: createNewLocationInvitationBulk
  })
};